import { render, staticRenderFns } from "./Cuadro11.vue?vue&type=template&id=68250580&scoped=true&"
import script from "./Cuadro11.vue?vue&type=script&lang=js&"
export * from "./Cuadro11.vue?vue&type=script&lang=js&"
import style0 from "./Cuadro11.vue?vue&type=style&index=0&id=68250580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68250580",
  null
  
)

export default component.exports